export const Bestseller  = [
    {
        id: 1,
        title: "Anthurium",
        img: require("./Featuredimges/img1.jpg"),
        price:80,
        rating:3.5,
        Availability: "Pre-Order",
        reviews: 0,
        Brand: "Apple",
        ProductCode: "Product 16",
        Discount:2,
        quantity:0,
    },
    {
        id: 2,
        title: "Cactus",
        img: require("./Featuredimges/img2.jpg"),
        price:30.7,
        rating:2,
        Availability: "Pre-Order",
        reviews: 0,
        Brand: "Apple",
        ProductCode: "Product 16",
        Discount:2,
        quantity:0,
    },
    {
        id: 3,
        title: "Anthurium",
        img: require("./Featuredimges/img3.jpg"),
        price:90,
        rating:3.5,
        Availability: "inStock",
        reviews: 0,
        Brand: "Apple",
        ProductCode: "Product 16",
        Discount:2,
        quantity:0,
    },
]